import { DocumentCardsWrapper } from "../components/DocumentCardsWrapper";
import { DocumentsPageDocumentCards } from "./DocumentCards";
import { useDocumentsPageApiContext } from "./useApiProvider";

export function DocumentsPageMandatoryDocumentsContent() {
  const {
    mandatoryRequirementsQuery: { data: mandatoryRequirements },
  } = useDocumentsPageApiContext();

  return (
    <DocumentCardsWrapper sx={{ overflow: "visible" }}>
      <DocumentsPageDocumentCards documents={mandatoryRequirements} />
    </DocumentCardsWrapper>
  );
}
